import useCreateReducer from "./createReducer";
import useCreateSelector from "./createSelector";
import useQuickFunctions from "./quickFunctions";
import usePermissions from "./usePermissions";
import useSettingsSecrets from "./useSettingsSecrets";

const useHelpers = () => {
  return {
    useCreateSelector,
    useCreateReducer,
    useQuickFunctions,
    usePermissions,
    useSettingsSecrets,
  };
};

export default useHelpers;
